module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFRJREFUeNpiFOp+ywAF/kDMBMTrQRwWqCAfEE+FsvcC8ScmKKcNiKWhGMQGa7UA4kwGBACxLUASoUB8D0kCxA4FSRQD8VwkCRC7mIkBB6CiBECAAQA2BQv80W5vcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.png
// module id = rOIf
// module chunks = 1